import preloadChunks from '@/routes/preloadChunks.util';

const settingsRoutes = [
  {
    path: 'settings',
    lazy: async () => ({
      Component: (await preloadChunks['settings.main']()).default,
    }),
    children: [
      {
        path: 'api-keys/new',
        lazy: async () => ({
          Component: (await preloadChunks['settings.apiKeys.addNew']()).default,
        }),
      },
    ],
  },
];

export default settingsRoutes;
